module.exports = __webpack_public_path__ + "img/poke_prep.b2842121.jpg";